import initialStore from "../initialStore";
import {
    SET_USER,
    SET_IS_END_SILENT
} from "@actions/actionTypes";

export function userReducer(state = initialStore.user, action) {
    switch (action.type) {
        case SET_USER:
            if (!action.user) return action.user;
            return {
                ...action.user,
                profile: {
                    ...action.user.profile,
                    Apps: action.user.profile.Apps.split(',')
                }
            }
        default:
            return state;
    }
}


export function isEndSilentRequestReducer(state = false, action) {
    switch (action.type) {
        case SET_USER:
            return true;
        case SET_IS_END_SILENT:
            return action.isEndSilentRequest
        default:
            return state;
    }
}